import { useEffect } from 'react';
import { RefreshTypes } from '../typings/refresh';

export interface UseRefreshArgs {
  refreshEventType?: RefreshTypes;
  onRefresh: () => void;
}

export default function useRefresh({ refreshEventType, onRefresh }: UseRefreshArgs): void {
  useEffect(() => {
    const refreshEventHandler = () => {
      // if (refreshType === refreshEventType) {
      //   onRefresh();
      // }
    };

    document.addEventListener('reloadpagedata', refreshEventHandler);

    return () => document.removeEventListener('reloadpagedata', refreshEventHandler);
  }, [refreshEventType, onRefresh]);
}
